module.exports = __webpack_public_path__ + "img/hot.cdc17ce2.svg";